import React from 'react';

const ModalClose = ({ onClick }) => {
    return (
        <span onClick={onClick} className="modal-close btn btn-close icon-only btn-close-large">
            <i className="ion ion-close-round" />
        </span>
    );
}

export default ModalClose;
